export const SalesQuotationCheckBoxes=[
    {
        key:1,
        nameAr:'مع قواعد خشبية',
        nameEn:'Wooden Bases Included',
    },
   
    {
        key:2,
        nameAr:'مع تنزيل',
        nameEn:'Unloading Included',
    },
    
]